function main() {
    document.addEventListener("DOMContentLoaded", () => {
        function updateHeaderHeight() {
            const header = document.querySelector(".header");

            let extra = 0;

            if (window.outerWidth > 908) {
                extra = 60
            }

            if (header) {
                document.documentElement.style.setProperty("--header-height", `${header.offsetHeight + extra}px`);
            }
        }

        updateHeaderHeight(); // Set initial height

        // Use ResizeObserver to track changes in height dynamically
        const observer = new ResizeObserver(updateHeaderHeight);
        const header = document.querySelector(".header");
        if (header) {
            observer.observe(header);
        }

        // Fallback: Listen to window resize in case ResizeObserver isn't reliable
        window.addEventListener("resize", updateHeaderHeight);
    });
}

main()
